import { render, staticRenderFns } from "./elecSolution.vue?vue&type=template&id=5d606fa4&"
import script from "./elecSolution.vue?vue&type=script&lang=js&"
export * from "./elecSolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports